// Minimal client-side CSV download used by the Sales / Expenses report pages.
// Mirrors the escaping + UTF-8 BOM behaviour of the shared ExportButton so
// spreadsheets open the file cleanly, but exposes a single-click download with
// a caller-controlled filename (the reports need exact `…-<period>.csv` names).

function toCsvValue(v: unknown): string {
  if (v === null || v === undefined) return ''
  const s = String(v)
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`
  }
  return s
}

export function downloadCsv(filename: string, headers: string[], rows: (string | number)[][]): void {
  const BOM = '﻿'
  const lines = [
    headers.map(toCsvValue).join(','),
    ...rows.map(r => r.map(toCsvValue).join(',')),
  ]
  const blob = new Blob([BOM + lines.join('\n')], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`
  a.click()
  URL.revokeObjectURL(url)
}
